import React from 'react'

const Video = () => {
  return (
    <div className='video-container'>
      <iframe
        width='100%'
        height='100%'
        src='https://www.youtube.com/embed/2Qb1wl75cqg'
        title='YouTube video player'
        frameborder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowfullscreen
      ></iframe>
    </div>
  )
}

export default Video
